import { Modal, Snackbar, Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { useEffect, useState } from "react";
import closeIcon from "src/assets/images/icon_close.svg";
import copyIcon from "src/assets/images/icon_copy.png";
import { StakingPoolItemModel } from "src/models/StakingPool";
import { formatNumber } from "src/utils/numberUtils";
import { DelegateSteps } from "./DelegateSteps";

type DelegateTokenModalProps = {
  poolItem: StakingPoolItemModel | undefined;
  visible: boolean;
  handleClose: any;
};

export const DelegateTokenModal = (props: DelegateTokenModalProps) => {
  const { poolItem } = props;
  const [copySuccessToastVisible, setCopySuccessToastVisible] = useState(false);

  const showRewardRow =
    !isNaN(Number(poolItem?.rewards)) && Number(poolItem?.rewards) > 0;

  useEffect(() => {
    setCopySuccessToastVisible(false);
  }, [props.visible]);

  if (!poolItem) {
    return null;
  }

  return (
    <Modal
      open={props.visible}
      onClose={() => {
        props.handleClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        pt="22px"
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        sx={{
          backgroundColor: "#23292F",
          width: "800px",
          paddingBottom: "50px",
          borderRadius: "20px",
          margin: "auto",
          marginTop: "120px",
        }}
      >
        <Stack
          direction="row"
          alignSelf="stretch"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="bold" fontSize="22px" color="white" ml="50px">
            Delegate {poolItem.symbol}
          </Typography>

          <Box
            width="23px"
            height="23px"
            mr="20px"
            sx={{
              cursor: "pointer",
            }}
            onClick={() => {
              props.handleClose();
            }}
          >
            <img src={closeIcon} width="100%" alt="close" />
          </Box>
        </Stack>

        <Stack
          width="640px"
          height="50px"
          mt="30px"
          alignSelf="center"
          direction="row"
          alignItems="center"
          sx={{
            backgroundColor: "#304D5B",
            borderRadius: "10px",
          }}
        >
          <Typography fontSize="16px" color="#b6b6b6" ml="10px" width="136px">
            Delegate Address
          </Typography>

          <Typography
            variant="bold"
            fontSize="18px"
            lineHeight="18px"
            textAlign="end"
            color="white"
            flex={1}
            mr="9px"
          >
            {poolItem.omitAddress || "none"}
          </Typography>

          {poolItem.validatorAddress && (
            <Box
              width="20px"
              height="20px"
              mr="10px"
              sx={{
                cursor: "pointer",
              }}
              onClick={() => {
                navigator.clipboard.writeText(poolItem.validatorAddress).then(
                  function () {
                    setCopySuccessToastVisible(true);
                  },
                  function (err) {}
                );
              }}
            >
              <img src={copyIcon} width="100%" alt="close" />
            </Box>
          )}
        </Stack>

        <Box m="31px 50px 0">
          <Typography
            variant="bold"
            fontSize="18px"
            lineHeight="18px"
            color="primary"
          >
            Delegate Steps
          </Typography>

          <DelegateSteps nodeName={poolItem.nodeName} />
        </Box>

        <Box m="24px 50px 0" alignSelf="stretch">
          <Typography
            variant="bold"
            fontSize="18px"
            lineHeight="18px"
            color="primary"
          >
            Current Performance
          </Typography>

          <Stack
            mt="20px"
            height="31px"
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              borderBottom: "1px solid #2E3743",
            }}
          >
            <Typography fontSize="16px" color="#848484">
              Delegated amount
            </Typography>

            <Typography fontSize="16px" color="secondary">
              {formatNumber(poolItem.delegateAmount)} {poolItem.symbol}
            </Typography>
          </Stack>

          <Stack
            height="31px"
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              borderBottom: "1px solid #2E3743",
            }}
          >
            <Typography fontSize="16px" color="#848484">
              Amount of delegated address
            </Typography>

            <Typography fontSize="16px" color="secondary">
              {formatNumber(poolItem.stakerAmount)}
            </Typography>
          </Stack>

          {showRewardRow && (
            <Stack
              height="31px"
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                borderBottom: "1px solid #2E3743",
              }}
            >
              <Typography fontSize="16px" color="#848484">
                Earned Reward
              </Typography>

              <Typography fontSize="16px" color="secondary">
                {formatNumber(poolItem.rewards)} {poolItem.symbol}
              </Typography>
            </Stack>
          )}

          <Stack
            height="31px"
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              borderBottom: "1px solid #2E3743",
            }}
          >
            <Typography fontSize="16px" color="#848484">
              Slash record
            </Typography>

            <Typography fontSize="16px" color="secondary">
              {poolItem.slash}
            </Typography>
          </Stack>
        </Box>

        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={copySuccessToastVisible}
          onClose={() => {
            setCopySuccessToastVisible(false);
          }}
          message="Delegated Address copied"
          autoHideDuration={2000}
        />
      </Box>
    </Modal>
  );
};
